import { modules } from "../../../pages/Explore/utils.js";

export const LICENSE_TO_FEATURE = Object.fromEntries(
  modules.map(({ id, title }) => [id, title]),
);

// TODO: Add to Explore/utils.js once feature dialler and projects are added there
export const FEATURE_LABEL_MAP = {
  Projects: "projectsRequested",
  Sourcing: "sourcingRequested",
};
